// @flow
import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";
import enhanceWithClickOutside from "react-click-outside";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import { Icon, LocaleLink } from "../";
import uaeFlag from "../../../images/common/uae-flag1.svg";
import ksaFlag from "../../../images/common/ksa-flag1.svg";
import cnFlag from "../../../images/common/cn-flag1.svg";
import egyptFlag from "../../../images/common/egypt-flag1.svg";
import styles from "./CountryToggle.scss";

const countries = [
  {
    icon: uaeFlag,
    name: I18n.getText("header.uae"),
    country_code: "AE"
  },
  {
    icon: ksaFlag,
    name: I18n.getText("header.ksa"),
    country_code: "SA"
  },
  {
    icon: cnFlag,
    name: I18n.getText("header.china"),
    country_code: "CN"
  },
  {
    icon: egyptFlag,
    name: I18n.getText("header.egypt"),
    country_code: "EG"
  }
];

class CountryToggle extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    showList: false,
    selected: 0,
    newCountryList: []
  };

  componentDidMount = () => {
    const { partnerCountries } = this.props;
    let { newCountryList } = this.state;
    if (partnerCountries && !_.isEmpty(partnerCountries)) {
      newCountryList = this.merge(partnerCountries, countries, "country_code");
    }
    this.setState({
      newCountryList
    });
    const match =
      newCountryList &&
      !_.isEmpty(newCountryList) &&
      newCountryList.find(
        eachCountry =>
          eachCountry &&
          eachCountry.country_code.toLowerCase() === Helper.getCountry()
      );
    if (match) {
      const selected = newCountryList.indexOf(match);
      this.setState({
        selected
      });
    }
  };

  merge = (arr1, arr2, key) => {
    var criteria = {};
    criteria[key] = null;
    return _.map(arr1, function(item) {
      criteria[key] = item[key];
      return _.merge(item, _.find(arr2, criteria));
    });
  };

  toggleList = () => {
    this.setState(prevState => ({
      showList: !prevState.showList
    }));
  };

  handleClickOutside = () => {
    this.setState({ showList: false });
  };

  notificationClick = (id_notification, link) => {
    const obj = {
      id_notification,
      is_read: true
    };
    this.props.readNotification(obj);
    this.handleClickOutside();
    window.open(link);
  };

  selectCountry = country => {
    if (country && country.country_code) {
      const selected = countries.indexOf(country);
      this.setState({
        selected
      });
      Helper.toggleCountry(country.country_code.toLowerCase());
    }
  };

  render() {
    const { data, user, seller, signout } = this.props;
    const { selected, newCountryList } = this.state;
    const countryList =
      newCountryList && !_.isEmpty(newCountryList)
        ? newCountryList.map((country, index) => (
            <a onClick={() => this.selectCountry(country)}>
              <div
                className={`${styles.each}  ${
                  newCountryList &&
                  newCountryList.length > 0 &&
                  country &&
                  newCountryList[selected] &&
                  newCountryList[selected].country_code === country.country_code
                    ? styles.selected
                    : ""
                }`}
              >
                <div className={styles.name}>
                  <img
                    src={country.icon}
                    height={20}
                    className={styles.flagImg}
                    alt="badgeImage"
                  />

                  <span className={styles.uName}> {country.name}</span>
                </div>
                {newCountryList &&
                newCountryList.length > 0 &&
                country &&
                newCountryList[selected] &&
                newCountryList[selected].country_code ===
                  country.country_code ? (
                  <Icon name={"tick"} className={styles.radio} />
                ) : (
                  ""
                )}
              </div>
            </a>
          ))
        : "";
    return (
      <div className={styles.notificationIcon}>
        {newCountryList &&
          !_.isEmpty(newCountryList) &&
          newCountryList[selected] && (
            <div className={styles.icon} onClick={this.toggleList}>
              <img
                src={newCountryList[selected] && newCountryList[selected].icon}
                height={20}
                className={styles.flagImg}
                alt="badgeImage"
              />
              <span className={styles.uName}>
                {" "}
                {newCountryList[selected].name}
              </span>
              <Icon
                name={this.state.showList ? "angle-up" : "angle-down"}
                className={styles.arr}
              />
              {/**<span className={styles.uName}>{user && user.firstName}</span>
          <Icon
            name={this.state.showList ? "angle-up" : "angle-down"}
            className={styles.arr}
          />**/}
            </div>
          )}

        {this.state.showList && (
          <div className={styles.list}>
            <div className={styles.listCtr}>
              <div className={styles.listWrapper}>
                <div className={styles.menuItems}>{countryList}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default enhanceWithClickOutside(CountryToggle);



// WEBPACK FOOTER //
// ./src/components/common/countryToggle/CountryToggle.js